export default "__VITE_ASSET__DRK_PPA9__"